<template>
  <div>
    <h3 class="title-page">{{ $t("productDelivery") }}</h3>
    <div class="admin_container">
      <div class="division_main">
        <div class="d-flex justify-end align-center mb-3">
          <ConfirmKeyDialog
            ref="confirmKeyDialogRef"
            @eimzo-signed="showSentMessage"
          ></ConfirmKeyDialog>
        </div>
        <div class="table_cover mobile_simple" style="overflow: auto">
          <TableWithFilter
            :headers="headers"
            :items.sync="orders"
            child-key="items"
            fixed-header
            handlerValue="parentNumb"
            item-key="id"
            @onException="(e) => setResponseError({ error: e })"
          >
            <template #filter.parentNumb>
              <div class="pa-1">
                <CustomInputText
                  only="number"
                  clearable
                  class="user_input no-margin"
                  @input="getOrdersByFilter"
                  v-model="productDeliveryFilter.parentNumbSearch"
                  type="text"
                ></CustomInputText>
              </div>
            </template>
            <template #filter.productName>
              <div class="pa-1">
                <CustomInputText
                  clearable
                  class="user_input no-margin"
                  @input="getOrdersByFilter"
                  v-model="productDeliveryFilter.allSearch"
                  type="text"
                ></CustomInputText>
              </div>
            </template>

            <template #expandBtn="{ openHandler, item }">
              <TriangleBtn
                :active="item.show"
                :loading="item.loading"
                @click="openHandler(item, getOrderItems)"
              />
            </template>

            <template #child.hasProductCount="{ item, child }"
              >{{ child.remains }}
            </template>

            <template #child.action="{ item, child }">
              <VTooltip color="#fff" left nudge-right="10" nudge-top="35">
                <template v-slot:activator="{ on, attrs }">
                  <VBtn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="openViewDialog(item, child)"
                  >
                    <VueIcon icon="newEyeIcon"></VueIcon>
                  </VBtn>
                  <VBtn
                    v-bind="attrs"
                    v-on="on"
                    class="new_style"
                    @click="openViewDialog(item, child)"
                  >
                    <VueIcon icon="newCheckIcon"></VueIcon>
                  </VBtn>
                </template>
                <span>{{ $t("distribution") }}</span>
              </VTooltip>
            </template>
            <template #item.count="{ item }">
              <div>
                <p class="mb-1" style="width: 150px">
                  {{ $t("givenProductQuantity") }}:
                  <b>{{ +item.count }}</b>
                </p>
                <p class="mb-1">
                  {{ $t("givenProduct") }}:
                  <b>{{ item.given }}</b>
                </p>
                <p class="mb-1">
                  {{ $t("inWarehouse") }}:
                  <b>{{ item.hasProductCount }}</b>
                </p>
              </div>
            </template>
            <template #child.count="{ child }">
              <span>{{ child.remains }}</span>
            </template>
          </TableWithFilter>
        </div>
        <VuePagination
          v-model="page"
          :length="lastPage"
          @input="changePage"
          go-to
        />
      </div>
    </div>
    <ProductDistributionDialog
      ref="distributionDialogRef"
      @productGiven="updateTable"
    ></ProductDistributionDialog>
  </div>
</template>

<script>
const FilterOmtkDelivery = {
  parentNumbSearch: null,
  allSearch: null,
};

import {
  downloadBlobFile,
  debounce,
  getQueryByKey,
  getQueryPage,
  makerPagination,
} from "@/utils/pureFunctions";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import TriangleBtn from "@/components/table-with-children/triangleBtn";
import ProductDistributionDialog from "@/components/omtk/ProductDistributionDialog.vue";
import ConfirmKeyDialog from "@/components/ConfirmKeyDialog.vue";

export default {
  name: "delivery-product",
  components: {
    VuePagination,
    TableWithFilter,
    TriangleBtn,
    ProductDistributionDialog,
    ConfirmKeyDialog,
  },
  data() {
    return {
      productDeliveryFilter: {
        ...FilterOmtkDelivery,
      },
      loading: false,
      page: 1,
      orders: [],
      lastPage: 0,
      configuration: {
        total: 0,
        limit: 10,
        page: 1,
      },
    };
  },
  computed: {
    headers() {
      return [
        {
          value: "parentNumb",
          text: this.$t("numberRequest"),
        },
        {
          value: "departmentName",
          text: this.$t("department"),
        },
        {
          value: "productName",
          text: this.$t("productName"),
        },
        {
          value: "count",
          text: this.$t("count"),
        },
        {
          value: `unit_type_name_${this.$i18n.locale}`,
          text: this.$t("unit"),
        },
        {
          value: "accountingCode",
          text: this.$t("accountingCode"),
        },
        {
          value: "productCategory",
          text: this.$t("productCategory"),
        },
        {
          value: "contractCode",
          text: this.$t("contractNumber"),
        },
        {
          value: "productType",
          text: this.$t("typeProduct"),
        },
        {
          value: "wareHouseName",
          text: this.$t("warehouse"),
        },
        {
          value: "date",
          text: this.$t("dataOfReceipt"),
        },
        {
          value: "action",
          text: this.$t("action"),
        },
      ];
    },
  },
  methods: {
    updateTable() {
      this.getOrders();
      this.$refs.confirmKeyDialogRef.getListItemsWithKey();
    },
    showSentMessage() {
      this.setSuccess({ text: this.$t("productIssued") });
    },
    openViewDialog(order, child) {
      const { distributionDialogRef } = this.$refs;
      distributionDialogRef.open(order, child);
    },
    getOrdersByFilter: debounce(async function () {
      this.showLoading();
      this.page = 1;
      await this.getOrders();
      await this.$router
        .replace({
          query: { page: this.page, ...this.productDeliveryFilter },
        })
        .catch((err) => {
          console.warn(err);
        });
      this.clearLoading();
    }, 300),
    async changePage() {
      this.showLoading();
      await this.getOrders();
      await this.$router.replace({
        query: { page: this.page, ...this.productDeliveryFilter },
      });
      this.clearLoading();
    },
    async getOrders() {
      let params = {
        ...this.productDeliveryFilter,
        page: this.page - 1,
        limit: 10,
        forProducing: true,
        removeStatus:
          "removeStatus=REJECT_ORDER_ITEM&removeStatus=APPLICATION_REJECTED_OZL",
      };
      try {
        const {
          data: { data: ordersData, total: orderTotal },
        } = await this.$http.get("orders/items-omtk", { params });
        this.orders = ordersData.map((item) => {
          item.loading = false;
          item.show = false;
          item.items = [];
          return item;
        });
        this.lastPage = makerPagination({
          limit: params.limit,
          total: orderTotal,
        }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getOrderItems(item) {
      const { page, limit } = this.configuration;
      let params = {
        productId: item.productId,
        page: page - 1,
        limit,
        ...this.productDeliveryFilter,
      };
      const {
        data: { data },
      } = await this.$http.get("partition/list", {
        params,
      });
      item.items = data;
    },
    async getShippedProducts() {
      try {
        this.loading = true;
        const { data } = await this.$http.get("reports/for-omtk");
        // downloadReport(data, selectedFileType) {
        let blob = new Blob([data], { type: "xls" });
        downloadBlobFile(blob, `Продукты отправлены.xls`);
        // },
        // this.downloadReport(data, "xls");
        // console.log(data);
        this.getGivenOmtkProducts();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    const { query } = this.$route;
    this.page = getQueryPage(query.page);
    this.productDeliveryFilter = getQueryByKey(FilterOmtkDelivery, query);
    this.showLoading();
    await this.getOrders();
    this.clearLoading();
  },
};
</script>
